export default {
  methods: {
    formatProductionCode(stockItem) {
      const {
        deliveryNote, productionDate, stockType, packSize,
      } = stockItem;
      return `AO-${(this.formatDate(productionDate))}-${deliveryNote?.farm?.code}-${stockType ?? '?????'}-${packSize ?? '???'}`;
    },
  },
};
